// extracted by mini-css-extract-plugin
export var col_cost = "style-module--col_cost--a1d85";
export var col_costWrapper = "style-module--col_cost-wrapper--0c8ce";
export var col_costWrapperSubtitle = "style-module--col_cost-wrapper--subtitle--f7c65";
export var col_costWrapperTitle = "style-module--col_cost-wrapper--title--b3e04";
export var cost = "style-module--cost--b550c";
export var cost_bg = "style-module--cost_bg--50953";
export var cost_row = "style-module--cost_row--fc1e3";
export var newcost = "style-module--newcost--077f2";
export var oldcost = "style-module--oldcost--bfaad";